module.exports = __webpack_public_path__ + "img/274361812_301347255235608_839699634103727815_n.e6082de9.jpg";